import { Link } from 'react-router-dom';
import { Card } from '@components/Card';
import { Page } from '@components/Page';
import { PageWidget } from '@components/PageWidget';
import { Spinner } from '@components/Spinner';
import { Table } from '@/Table';
import { useEarnings } from '@/domains/Earnings/hooks';
import { TableLinks } from './styled';
import { getEarningsTableColumns } from '@/domains/Earnings/utils';
import { useMemo } from 'react';

function Dashboard() {
  const earningsTableColumns = getEarningsTableColumns();
  const { data: earnings, isLoading: isEarningsLoading } = useEarnings({
    limit: 5,
  });
  const earningsTableMetaData = useMemo(
    () => ({ ...earnings?.metadata, count: 6 }),
    [earnings?.metadata]
  );

  return (
    <Page title='Dashboard'>
      <PageWidget fullWidth={false}>
        <Card />
      </PageWidget>
      <PageWidget title='Earnings'>
        {!isEarningsLoading ? (
          <>
            {earnings?.data?.length ? (
              <>
                <Table
                  data={earnings.data}
                  columns={earningsTableColumns}
                  metadata={earningsTableMetaData}
                  onPageChange={() => {}}
                />
                <TableLinks>
                  <Link to='/earnings'>See All</Link>
                </TableLinks>
              </>
            ) : (
              <p>You have no earnings yet.</p>
            )}
          </>
        ) : (
          <Spinner variant='small' />
        )}
      </PageWidget>
    </Page>
  );
}

export { Dashboard };
